import React from "react";

export const LitraMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="42" height="42" rx="12" stroke="rgba(185,192,204,0.35)" strokeWidth="1.5" />
    <path d="M16 13v22h13" stroke="#2E9E76" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="31" cy="16" r="3" fill="#B08D3C" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-semibold tracking-tight ${className}`}>Litrametry</span>
);

export const BrandLockup = ({ size = 28, textClass = "text-lg" }) => (
  <div className="flex items-center gap-2" data-testid="brand-lockup">
    <LitraMark size={size} />
    <Wordmark className={textClass} />
  </div>
);
